import React, { useState } from "react";
import {
  LayoutRow,
  LayoutData,
} from "../../../weekly-wins/TableLayoutComponents";
import {
  Badge,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { BiTrashAlt, BiMailSend } from "react-icons/bi";
import { MdOutlineMobileFriendly } from "react-icons/md";
import moment from "moment";
import { getShareUserDisplayName } from "../../../../utils/stringUtils";

const PaginatedUserList = ({
  sharedWithUsers = [],
  isMobile,
  tableCols,
  shareTrivvyViaSMS,
  shareTrivvyViaEmail,
  user,
  profilePicValidityCheck,
  getInitials,
  removeUser,
  viewMember,
  page = 1,
  limit = 10,
  totalUsers = 0,
  listingType,
  usersLoading,
  hasSearched,
  survey,
  trivvyResults,
  handlePageChange = () => {},
  emailSmsSendModal
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingDeleteUser, setPendingDeleteUser] = useState(null);

  if (usersLoading)
  return null;

  if (!sharedWithUsers.length) {
    // New Users tab with nothing selected — initial state, after "Deselect to
    // remove all users", or a filter that matched nobody: show the guidance hint.
    if (listingType === "new") {
      return (
        <div className="text-center share_empty_hint">
          Click <b>"Select all users"</b> OR filter by your desired parameter(s)
        </div>
      );
    }
    // Already Saved tab with nothing saved: render nothing. "No users found" is
    // intentionally not shown for any sharing type.
    return null;
  }



  const confirmDelete = (user) => {
    if (listingType === "saved") {
      setPendingDeleteUser(user);
      setShowConfirmModal(true);
    } else {
      if (user) removeUser(user.mobileNumber, user.userId);
    }
  };

  const handleConfirmDelete = () => {
    if (pendingDeleteUser) {
      removeUser(pendingDeleteUser.mobileNumber, pendingDeleteUser.userId);
      setPendingDeleteUser(null);
      setShowConfirmModal(false);
    }
  };

  const handleCancelDelete = () => {
    setPendingDeleteUser(null);
    setShowConfirmModal(false);
  };

  const deleteButtonsDisabled = listingType === "saved" && showConfirmModal;

  return (
    <>
      <div className="share_rows_scroll" style={{

    maxHeight:"300px",
    overflowY:"scroll"
      }}>
        {sharedWithUsers.map((item, itemIndex) => {
          if (shareTrivvyViaSMS && !item && item.mobileNumber) return null;
            let dateTrivvySentValue = trivvyResults && trivvyResults.length > 0 ?  trivvyResults.find(e=> e.userId && (e.userId.email == item.email)) : null
            dateTrivvySentValue = dateTrivvySentValue ? dateTrivvySentValue.dateTrivvySent : null;


          const initials =
            item && item.value === user.profile._id
              ? getInitials(user.profile)
              : getInitials(item);

          const avatar = profilePicValidityCheck(item && item.profilePic) ? (
            <div className="list-item__avatar">
              <img src={item.profilePic} />
            </div>
          ) : (
            <span className="list-item__avatar" data-letters={initials}></span>
          );

          const nameDisplay =
            item && item.value === user.profile._id
              ? "You"
              : getShareUserDisplayName(item, survey);

          if (isMobile) {
            return (
              <LayoutData
                fullWidth
                className="col-pl-0 d-block bg-white"
                key={itemIndex}
              >
                <div className="my-2 pl-2 d-flex align-items-center">
                  <div className="grp_member_profile_image cursor-pointer">
                    {avatar}
                  </div>
                  <div className="">
                    <div
                      className="linkedToolView"
                      onClick={() => viewMember(item)}
                    >
                      {nameDisplay}
                    </div>
                  </div>
                  <Button
                    onClick={() => confirmDelete(item)}
                    color="danger"
                    size="sm"
                    className="ml-auto mr-3 share_filter_trash_btn"
                    disabled={deleteButtonsDisabled}
                  >
                    <BiTrashAlt size={18} />
                  </Button>
                </div>
              </LayoutData>
            );
          }

          return (
            <LayoutRow className="ml-0 mr-0" key={itemIndex}>
              <LayoutData colWidth={tableCols.user} className="bg-white">
                <div className="my-0 pl-2 d-flex align-items-center">
                  <div className="grp_member_profile_image cursor-pointer">
                    {avatar}
                  </div>
                  <div className="">
                    <span>{nameDisplay}</span>
                  </div>
                </div>
              </LayoutData>
              {(shareTrivvyViaSMS) && (
                <LayoutData
                  colWidth={tableCols.phoneNumber}
                  className="bg-white"
                >
                  <span>{(item && item.mobileNumber) || ""}</span>
                </LayoutData>
              )}

              {shareTrivvyViaEmail && (
                <LayoutData colWidth={tableCols.email} className="bg-white">
                  <span>{item && item.email}</span>
                </LayoutData>
              )}


        
        {/* <LayoutData colWidth={tableCols.sharedVia} className="bg-white">
                {item && item.shareMediums && item.shareMediums.length ? (
                  <div className="trivvy-share-via-container">
                    {item.shareMediums.includes("EMAIL") &&
                    shareTrivvyViaEmail ? (
                      <div>
                        <BiMailSend
                          size={"17px"}
                          style={{ marginRight: "3px" }}
                        />
                        <span className="font-13px">
                          {item.emailDate
                            ? moment(item.emailDate).format("MM/DD/YYYY")
                            : ""}
                        </span>
                      </div>
                    ) : (
                      item.shareMediums.includes("SMS") && (
                        <div>
                          {item.smsDate && (
                            <MdOutlineMobileFriendly size={"14px"} />
                          )}
                          <span className="font-13px">
                            {item.smsDate
                              ? moment(item.smsDate).format("MM/DD/YYYY")
                              : ""}
                          </span>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
              </LayoutData> */}
        
            


                <LayoutData
                  colWidth={tableCols.dateSent}
                  className="bg-white addedOnDateCss"
                >
                  <span className="share_date_muted" >
                {

                  emailSmsSendModal && emailSmsSendModal.type === "EMAIL_LINK" && item.emailDate ? moment(item.emailDate).format("MM/DD/YYYY") :
                  emailSmsSendModal && emailSmsSendModal.type !== "EMAIL_LINK" && item.smsDate ? moment(item.smsDate).format("MM/DD/YYYY") :
                  dateTrivvySentValue ? moment(dateTrivvySentValue).format("MM/DD/YYYY") :
                ""
                }
                  </span>
               
                </LayoutData>


           {survey.isMessaging!=true?
                <LayoutData
                  colWidth={tableCols.date}
                  className="bg-white addedOnDateCss"
                >
               {item.isSubmitted && (item.isSubmittedDate || item.lastUpdate) ? (
                    <span className="share_date_pill">
                      {item.isSubmittedDate
                        ? moment(item.isSubmittedDate).format("MM/DD/YYYY")
                        : moment(item.lastUpdate).format("MM/DD/YYYY")}
                    </span>
                  ) : null}
                </LayoutData>
                :null}
    

              <LayoutData colWidth={tableCols.action} className="bg-white">
                <div className="d-flex">
                  <Button
                    onClick={() => confirmDelete(item)}
                    color="danger"
                    size="sm"
                    disabled={deleteButtonsDisabled}
                  >
                    <BiTrashAlt size={18} />
                  </Button>
                </div>
              </LayoutData>
            </LayoutRow>
          );
        })}
      </div>

      {/* Confirmation Modal */}
      <Modal isOpen={showConfirmModal} toggle={handleCancelDelete}>
        <ModalBody>
          <p className="mb-0">
            Deleting this user means they will not receive the survey questions
            that they have not completed yet. Instead, you can keep them here
            and select the option to not resend the Trivvy to them in a later
            step.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
          <Button color="secondary" onClick={handleCancelDelete}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PaginatedUserList;
